var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.notices != null && this.notices.length > 0)?_c('div',_vm._l((this.notices),function(notice,i){return _c('v-alert',{key:i,attrs:{"type":"error"}},[_vm._v(_vm._s(notice.message))])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }